<template>
  <BaseSlideOverModal
    v-model:is-modal-open="localOpen"
    width="xl"
    :footer="false"
  >
    <template #body>
      <div class="flex max-h-full w-full flex-col gap-3">
        <ListItemChooser
          :item-type-available="itemTypeAvailable"
          :selected-category="selectedCategory"
          :can-edit-category="canEditCategory"
          :already-added-items="selectedItems"
          :hide-quantity-input="hideQuantityInput"
          :hide-price="hidePrice"
          :hide-stock-disponibility="hideStockDisponibility"
          :funeral-home-id="funeralHomeId"
          :display-pack-tab="displayPackTab"
          :disable-buttons="disableButtons"
          :currency="defaultCurrency"
          :called-context="calledContext"
          @selected-item="
            (selectedItem) => $emit('selected-item', selectedItem)
          "
        />
      </div>
    </template>
    <template #nested-modal>
      <slot name="nested-modal" />
    </template>
  </BaseSlideOverModal>
</template>

<script>
import BaseSlideOverModal from '@c/addf-package/components/modal/BaseSlideOverModal.vue'
import ListItemChooser from '@c/ListItemChooser.vue'
import { mapGetters } from 'vuex'

export default {
  name: 'ItemByCategoryModal',
  components: { ListItemChooser, BaseSlideOverModal },
  props: {
    open: {
      type: Boolean,
      required: true
    },
    canEditCategory: {
      type: Boolean,
      required: false,
      default: false
    },
    displayPackTab: {
      type: Boolean,
      required: false,
      default: true
    },
    selectedCategory: {
      type: String,
      required: false,
      default: null
    },
    itemTypeAvailable: {
      type: Array,
      required: false,
      default: () => ['item', 'pack']
    },
    selectedItems: {
      type: Array,
      required: false,
      default: () => []
    },
    hideQuantityInput: {
      type: Boolean,
      required: false,
      default: false
    },
    hidePrice: {
      type: Boolean,
      required: false,
      default: false
    },
    hideStockDisponibility: {
      type: Boolean,
      required: false,
      default: false
    },
    funeralHomeId: {
      type: String,
      required: false,
      default: null
    },
    disableButtons: {
      type: Boolean,
      required: false,
      default: false
    },
    currency: {
      type: String,
      required: false,
      default: null
    },
    calledContext: {
      type: String,
      required: false,
      default: null
    }
  },
  emits: ['update:open', 'selected-item'],
  computed: {
    ...mapGetters({
      currencySettings: 'metadata/getDefaultCurrencyMetadata'
    }),
    defaultCurrency() {
      return this.currency ?? this.currencySettings
    },
    localOpen: {
      get() {
        return this.open
      },
      set(value) {
        this.$emit('update:open', value)
      }
    }
  },
  mounted() {}
}
</script>
